import { render, staticRenderFns } from "./purchaseRecord.vue?vue&type=template&id=cbc45264"
import script from "./purchaseRecord.vue?vue&type=script&lang=js"
export * from "./purchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./purchaseRecord.vue?vue&type=style&index=0&id=cbc45264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports